import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import './allreviews.css';

const AllReviews = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const sliderRef = useRef(null);
  const touchStartX = useRef(0);
  const isDragging = useRef(false);
  const dragStartX = useRef(0);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get('/api/reviews');
        setReviews(response.data || []);
      } catch (err) {
        setError(err.response ? err.response.data.error : 'Error fetching data');
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, []);

  const filteredReviews = productId
    ? reviews.filter(review => review?.productId?.toString() === productId)
    : reviews;

  const sortedReviews = filteredReviews.sort((a, b) => b.rating - a.rating);

  const toggleImageSize = (index) => {
    setEnlargedImage(enlargedImage === index ? null : index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev === 0 ? sortedReviews.length - 1 : prev - 1));
  };

  const nextReview = () => {
    setCurrentIndex((prev) => (prev === sortedReviews.length - 1 ? 0 : prev + 1));
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (!touchStartX.current) return;
    const deltaX = touchStartX.current - e.touches[0].clientX;
    if (deltaX > 50) {
      nextReview();
      touchStartX.current = null;
    } else if (deltaX < -50) {
      prevReview();
      touchStartX.current = null;
    }
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    dragStartX.current = e.clientX;
  };

  const handleMouseUp = (e) => {
    if (!isDragging.current) return;
    const diff = dragStartX.current - e.clientX;
    if (diff > 50) nextReview();
    else if (diff < -50) prevReview();
    isDragging.current = false;
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!sortedReviews.length) return <p>No reviews found.</p>;

  const review = sortedReviews[currentIndex];

  return (
    <div className="slider-wrapper">
      <h2><center>Reviews & Ratings</center></h2>
      <div
        className="review-container active"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        ref={sliderRef}
      >
        <div className="slider-controls-inside">
          <button className="arrow-btn inside left" onClick={prevReview}>
            <span className="arrow-icon">&#10094;</span>
          </button>
          <button className="arrow-btn inside right" onClick={nextReview}>
            <span className="arrow-icon">&#10095;</span>
          </button>
        </div>

        <div className="review-content">
          {review.imageUrl && (
            <div className="review-image-section">
              <img
                className={`reviewImg ${enlargedImage === currentIndex ? 'enlarged' : ''}`}
                    src={`${process.env.REACT_APP_BASE_URL}${review.imageUrl}`} // Using environment variable for image URL
                alt={`Review for Product ID: ${review.productId}`}
                loading="lazy"
                onClick={() => toggleImageSize(currentIndex)}
              />
            </div>
          )}
          <div className="review-text-section">
            <div className="review-rating">
              <span className="rating-label">Rating:</span> {renderStars(review.rating)}
            </div>
            <div className="review-comment">“{review.comment}”</div>
            <div className="review-date">
              Reviewed on: {new Date(review.reviewDate).toLocaleDateString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllReviews;
